import React from 'react';
import { Link } from 'react-router-dom';
import { MessageSquare, Store, ArrowRight, CheckCircle, Users, ShoppingBag, Zap } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function Portal() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 text-white flex flex-col">
      <header className="py-6 px-4">
        <div className="max-w-6xl mx-auto flex items-center justify-between">
          <div className="text-xs uppercase tracking-widest text-slate-400">Portal MARKIMAGEM</div>
          <div className="text-xs text-slate-500">Escolha um serviço para acessar</div>
        </div>
      </header>
      <main className="flex-1 flex items-center justify-center px-4 py-12">
        <div className="max-w-5xl w-full">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-black mb-3" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
              Bem-vindo ao <span className="bg-gradient-to-r from-emerald-400 to-fuchsia-400 bg-clip-text text-transparent">Portal MARKIMAGEM</span>
            </h1>
            <p className="text-slate-400 max-w-xl mx-auto">Escolha qual serviço deseja acessar</p>
          </div>
          <div className="grid md:grid-cols-2 gap-6">
            <ServiceCard
              to="/login"
              icon={<MessageSquare className="w-8 h-8" strokeWidth={2.5} />}
              gradient="from-emerald-500 to-green-600"
              shadowColor="shadow-emerald-500/30"
              title="MeuGestor"
              subtitle="Gestão de clientes + WhatsApp"
              description="CRM completo com envio automatizado de cobranças e lembretes via WhatsApp."
              features={['Cadastro de clientes ilimitado', 'WhatsApp integrado (Baileys)', 'Cobranças automatizadas', 'Templates de mensagens']}
              cta="Acessar MeuGestor"
            />
            <ServiceCard
              to="/loja"
              icon={<Store className="w-8 h-8" strokeWidth={2.5} />}
              gradient="from-fuchsia-500 to-purple-600"
              shadowColor="shadow-fuchsia-500/30"
              title="Loja MARKIMAGEM"
              subtitle="E-commerce de produtos digitais"
              description="Loja online para venda de IPTV, ativações e produtos digitais com PIX."
              features={['Catálogo de produtos', 'Carrinho + Checkout', 'Pagamento via PIX', 'Entrega automatizada']}
              cta="Entrar na Loja"
            />
          </div>
          <div className="text-center mt-10 text-xs text-slate-500">
            <span className="inline-flex items-center gap-1"><Zap className="w-3 h-3 text-fuchsia-400" /> Ambos os serviços no mesmo login unificado em breve</span>
          </div>
        </div>
      </main>
      <footer className="py-6 text-center text-xs text-slate-500 border-t border-slate-900">
        © 2026 MARKIMAGEM. Todos os direitos reservados.
      </footer>
    </div>
  );
}

const ServiceCard = ({ to, icon, gradient, shadowColor, title, subtitle, description, features, cta }) => (
  <Link to={to} className="group">
    <div className="bg-slate-900/60 border border-slate-800 rounded-2xl p-8 hover:border-white/20 transition-all hover:-translate-y-1 h-full flex flex-col">
      <div className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${gradient} flex items-center justify-center shadow-lg ${shadowColor} mb-6 group-hover:scale-105 transition-transform`}>
        {React.cloneElement(icon, { className: 'w-8 h-8 text-white' })}
      </div>
      <h2 className="text-2xl font-black mb-1" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>{title}</h2>
      <p className="text-sm text-slate-400 mb-4">{subtitle}</p>
      <p className="text-slate-300 mb-6">{description}</p>
      <ul className="space-y-2 mb-8 flex-1">
        {features.map((f, i) => (
          <li key={i} className="flex items-start gap-2 text-sm text-slate-300">
            <CheckCircle className="w-4 h-4 text-emerald-400 shrink-0 mt-0.5" />
            <span>{f}</span>
          </li>
        ))}
      </ul>
      <Button className={`w-full bg-gradient-to-r ${gradient} text-white hover:opacity-90 border-0`}>
        {cta} <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
      </Button>
    </div>
  </Link>
);
